
(function () {
  if (window.__vitaraAtcTracking) return;
  window.__vitaraAtcTracking = true;

  const SAUCO_VARIANT_ID = '53506739273909';
  const META_PIXEL_ID = '2010183749697521';

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const request = args[0];
      const url = typeof request === 'string'
        ? request
        : request?.url || '';

      const path = new URL(url, location.origin).pathname;

      if (!/\/cart\/add(?:\.js)?\/?$/.test(path)) {
        return response;
      }

      if (!response.ok) return response;

      const data = await response.clone().json();

      const items = Array.isArray(data.items)
        ? data.items
        : [data];

      const kachingItems = items.filter(item =>
        String(item.variant_id || item.id) === SAUCO_VARIANT_ID
      );

      if (!kachingItems.length) return response;

      const quantity = kachingItems.reduce(
        (total, item) => total + Number(item.quantity || 0),
        0
      );

      console.log('VITARA SAUCO: KACHING DETECTADO', {
        items: kachingItems,
        quantity
      });

      // El pack de 1 ya registra AddToCart con Shopify.
      // Solo enviamos manualmente para packs de 2 o 3.
      if (quantity !== 2 && quantity !== 3) {
        return response;
      }

      // Precio final del producto después del descuento.
      const value = kachingItems.reduce(
        (total, item) =>
          total + Number(
            item.final_line_price ?? item.line_price ?? 0
          ),
        0
      ) / 100;

      if (typeof window.fbq === 'function') {
        window.fbq('trackSingle', META_PIXEL_ID, 'AddToCart', {
          content_ids: [SAUCO_VARIANT_ID],
          content_type: 'product',
          num_items: quantity,
          value: value,
          currency: 'MXN'
        });

        console.log('VITARA SAUCO: AddToCart enviado a Meta', {
          quantity,
          value
        });
      }

    } catch (error) {
      console.warn('Vitara Sauco tracking:', error);
    }

    return response;
  };
})();
